import { MonitoringOngoing, MonitoringOngoingSpecialist } from '@features/monitoringOffer';
import { useLocation } from 'react-router-dom';

export const MonitoringOngoingProjects = () => {
	const isFarmerPath = useLocation().pathname.includes('farmer');
	return (
		<div className="w-full h-full max-w-[1440px] mx-auto px-5">
			{isFarmerPath ? <MonitoringOngoing /> : <MonitoringOngoingSpecialist />}
		</div>
	);
};
